export default __webpack_public_path__ + "static/media/Nocturne_tmb.8dd5170a.jpg";